<template>
    <span v-if="trophyIndex <= 2" :style="{color: indexToTrophyColor() }">
        <i class="fas fa-trophy"></i>&nbsp;
    </span>
</template>

<script>
    export default {
        props: {
            trophyIndex: {
                type: Number
            }
        },
        methods: {
            indexToTrophyColor: function(){
                if(this.trophyIndex == 0) {
                    return "#FFD700"
                }
                if(this.trophyIndex == 1) {
                    return "#c0c0c0"
                }
                if(this.trophyIndex == 2){
                    return "#cd7f32"
                }
            }
        }
    }
</script>
